import { render, staticRenderFns } from "./StructureGroup.vue?vue&type=template&id=b405a7ac&scoped=true&"
import script from "./StructureGroup.vue?vue&type=script&lang=js&"
export * from "./StructureGroup.vue?vue&type=script&lang=js&"
import style0 from "./StructureGroup.vue?vue&type=style&index=0&id=b405a7ac&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b405a7ac",
  null
  
)

export default component.exports